import $ from 'jquery'

import { MOBILE_SUBMENU_CLASS } from '../../constants/header'

import NavigationMobileAnimations from '../../utils/NavigationMobileAnimations'

class NavigationMobile {
  constructor(el) {
    this.el = el

    this.trigger = $('.main-nav-mobile__trigger', el)

    this.menuContainer = $('.main-nav-mobile__menu-container', el)
    this.menuScrollContainer = $('.main-nav-mobile__menu-scroll-container', el)
    this.subMenuScrollContainer = $('.main-nav-mobile__submenu-scroll-container', el)
    this.logoContainer = $('.main-nav-mobile__menu-logo-container', el)
    this.submenuHeader = $('.main-nav-mobile__submenu-header', el)
    this.submenuHeaderText = $('.main-nav-mobile__submenu-header-text', el)

    this.menuItems = $('.main-nav-mobile__menu-item', el)
    this.metaMenuItems = $('.main-nav-mobile__menu-meta-item', el)
    this.searchMetaItem = $('.main-nav-mobile__menu-meta-item--search.search-toggle')

    this.isActive = false
    this.activeMenuItemParent = null
    this.activeSubmenu = null

    this.mobileAnimations = new NavigationMobileAnimations(this.el, {
      menuContainer: this.menuContainer,
      menuScrollContainer: this.menuScrollContainer,
      subMenuScrollContainer: this.subMenuScrollContainer,
      menuItems: this.menuItems,
      metaMenuItems: this.metaMenuItems,
    })

    this.openAnimation = this.mobileAnimations.createOpenAnimation(this.logoContainer)
    this.closeAnimation = this.mobileAnimations.createCloseAnimation({
      onCompleteCallback: this.resetMenu.bind(this),
    })

    this.init()
  }

  init() {
    this.listen()
  }

  listen() {
    this.trigger.on('click', this.onTriggerClick.bind(this))
    this.menuItems.on('click', this.onMenuItemClick.bind(this))
    this.submenuHeader.on('click', this.onSubmenuHeaderClick.bind(this))
    this.searchMetaItem.on('click', () => {
      console.log('mobile meta search')
      this.deactivate()
    })
  }

  onTriggerClick() {
    this.isActive ? this.deactivate() : this.activate()
  }

  onMenuItemClick(e) {
    e.preventDefault()

    this.activateSubmenu(e.target)
    this.disallowTabActionOnElements(this.menuItems)
    this.disallowTabActionOnElements(this.metaMenuItems)
  }

  onSubmenuHeaderClick() {
    this.deactivateSubmenu()
    this.allowTabActionOnElements(this.menuItems)
    this.allowTabActionOnElements(this.metaMenuItems)
    this.focusTriggerButton()
  }

  activate() {
    this.openAnimation.play(0)
    this.isActive = true
    this.trigger.attr('aria-expanded', 'true')
  }

  deactivate() {
    this.closeAnimation.play(0)
    this.isActive = false
    this.trigger.attr('aria-expanded', 'false')
  }

  activateSubmenu(target) {
    const text = $(target).text()

    this.activeMenuItemParent = $(target).parent()
    this.activeSubmenu = $(`.${MOBILE_SUBMENU_CLASS}`, this.activeMenuItemParent)

    $(target).attr('aria-expanded', 'true')

    this.subMenuScrollContainer.append(this.activeSubmenu)
    this.submenuHeaderText.text(text)

    this.mobileAnimations.createSubMenuOpenAnimation(this.activeSubmenu).play()
  }

  /**
   * Sets 'tabindex' = 0 to array of elements to make them available for 'Tab' button
   * @param {HTMLElement[]} elements
   */
  allowTabActionOnElements(elements) {
    this.setTabindexOnItems(elements, '0')
  }

  /**
   * Sets 'tabindex' = -1 to array of elements to make them unavailable for 'Tab' button
   * @param {HTMLElement[]} elements
   */
  disallowTabActionOnElements(elements) {
    this.setTabindexOnItems(elements, '-1')
  }

  /**
   * Sets 'tabindex' = `${tabindexValue}` depending on tabindexValue variable.
   * @param {HTMLElement[]} items
   * @param {String} tabindexValue
   */
  setTabindexOnItems(items, tabindexValue) {
    items.each((_, item) => {
      item.setAttribute('tabindex', tabindexValue)
    })
  }

  focusTriggerButton() {
    this.trigger.get(0).focus()
  }

  deactivateSubmenu() {
    this.mobileAnimations
      .createSubMenuCloseAnimation({ onCompleteCallback: this.resetMenu.bind(this) })
      .play()
  }

  resetMenu() {
    this.menuScrollContainer.removeAttr('style')
    this.subMenuScrollContainer.removeAttr('style')

    if (!this.activeSubmenu) {
      return
    }

    this.activeMenuItemParent.children('.main-nav-mobile__menu-item').attr('aria-expanded', 'false')
    this.activeMenuItemParent.append(this.activeSubmenu)
    this.submenuHeaderText.text('')
    this.activeMenuItemParent = null
    this.activeSubmenu = null
  }
}

export default NavigationMobile
